import MentoringNewRequests from './MentoringNewRequests.vue';

export * from './types';
export default MentoringNewRequests;



// WEBPACK FOOTER //
// ./src/pages/profile/modules/mentoring/views/newrequests/index.ts